import { InventoryLevels } from "@constants/choices"
import { valueIsDefined } from "../../core/utils/utils"

function validateInventoryLevel(inventoryLevel) {
    let isValid = true
    let errors = {}

    if (!valueIsDefined(inventoryLevel.quantity_on_hand)) {
        isValid = false
        errors.quantity_on_hand = "Quantity on Hand is required."
    }

    if (!valueIsDefined(inventoryLevel.quantity_on_order)) {
        isValid = false
        errors.quantity_on_order = "Quantity on Order is required."
    }

    if (!valueIsDefined(inventoryLevel.quantity_desired)) {
        isValid = false
        errors.quantity_desired = "Quantity Desired is required."
    }

    if (!valueIsDefined(inventoryLevel.quantity_low_alert_threshold)) {
        isValid = false
        errors.quantity_low_alert_threshold = "Quantity Low Alert Threshold is required."
    }

    if (inventoryLevel.quantity_desired && parseFloat(inventoryLevel.quantity_desired) !== 0 && (parseFloat(inventoryLevel.quantity_low_alert_threshold) >= parseFloat(inventoryLevel.quantity_desired))) {
        isValid = false
        errors.quantity_low_alert_threshold = "The alert threshold must be lower than the desired quantity."
    }

    return { isValid, errors }
}

function getInventoryStatus(quantityOnHand, quantityOnOrder, quantityDesired, quantityLowAlertThreshold) {
    let quantity = parseFloat(quantityOnHand) + parseFloat(quantityOnOrder)

    if (parseFloat(quantityDesired) === 0) {
        return InventoryLevels.full
    }
    else if (quantity <= 0) {
        return InventoryLevels.depleted
    }
    else if (quantity <= parseFloat(quantityLowAlertThreshold)) {
        return InventoryLevels.low
    }
    else if (quantity < parseFloat(quantityDesired)) {
        return InventoryLevels.limited
    }
    else {
        return InventoryLevels.full
    }
}

export function filterInventoryLocationChoices(choices, currentValue = null) {
    if (!choices) {
        return []
    }

    const currentId = currentValue ? parseInt(currentValue) : null

    return choices.filter(choice => {
        // Always include the empty option
        if (!choice.value) {
            return true
        }

        // Include if it's the current selection (even if inactive)
        if (currentId && choice.value === currentId) {
            return true
        }

        // Otherwise, only include if active (or if is_active is undefined for backwards compatibility)
        return choice.is_active !== false
    })
}

export function shouldShowInventoryLocation(location, currentLocationId = null) {
    // Always include active locations (or if is_active is undefined for backwards compatibility)
    if (location.is_active !== false) {
        return true
    }

    // Include inactive location only if it's the currently selected one
    return currentLocationId && location.id === currentLocationId
}

export { getInventoryStatus, validateInventoryLevel }
